import React, { useEffect, useState } from 'react';
import { Col, Row } from 'reactstrap';
import MainCard from '../../../../components/MainCard';

//Context
import { useAuth } from '../../../../context/auth';

//Api
import tipoRequerimento_api from '../../../../api/tipoRequerimento_api';
import { showMessage } from '../../../../helpers/message';

// import { Container } from './styles';

function TiposdeRequerimentos({ requerimento, setRequerimento }) {
    const { setLoading } = useAuth();

    // state para pegar os requerimentos
    const [tipoRequerimentos, setTipoRequerimentos] = useState([]);


    useEffect(() => {
        setLoading(true);
        tipoRequerimento_api.getList("Munícipe")
            .then(response => {
                setTipoRequerimentos(response.data)
            })
            .catch(e => showMessage("Erro", e.message, "error", null))
            .finally(f => setLoading(false));
    }, []);

    const handleTipoRequerimento = (value) => {

        setRequerimento(prevsState => ({
            ...prevsState,
            tipoRequerimento_Id: value.id,
            tipoRequerimentoEtapa_Id: value.etapaInicial
        }))
    }

    return (
        <>
            <Row className='mx-4'>
                <Col md="12" lg="12">
                    <h6 style={{ color: "#666" }}>
                        Documentos necessários
                    </h6>
                </Col>
            </Row>
            <Row className='d-flex justify-content-center mb-4'>
                {!!tipoRequerimentos && tipoRequerimentos.map((value, index) => (
                    <Col md="12" lg="6" key={index}>
                        <MainCard className={value.id === requerimento.tipoRequerimento_Id ? "border border-2 border-success" : "border border-secondary"}>
                            <div
                                className={`d-flex text-center justify-content-center align-items-center flex-column gap-3`}
                                onClick={() => handleTipoRequerimento(value)}
                            >
                                <img src={value.arquivo} height="64px" className='rounded shadow' />
                                <h6 style={{ color: "#666" }}>{value.identificacao}</h6>
                            </div>
                        </MainCard>
                    </Col>
                ))}
            </Row>
        </>
    );
}

export default TiposdeRequerimentos;